import { Label } from "components/DesignSystem/TextInput/TextInput";

type FilingsListProps = {
  lines: string[];
};

// Matches FILING_LINE_PREFIX in churn_detail_handler.py -- any line without this
// prefix is an entity/state header, any line with it is a filing under that header.
const BULLET_PREFIX = "- ";

export const FilingsList = ({ lines }: FilingsListProps) => {
  const filingsCount = lines.filter((line) =>
    line.startsWith(BULLET_PREFIX)
  ).length;

  return (
    <div>
      <Label>{`Filings (${filingsCount})`}</Label>
      <div className="t-max-h-64 t-overflow-y-auto t-rounded t-border t-border-solid t-border-neutral-10 t-bg-surface-lighter-grey t-px-3 t-py-2">
        {lines.length === 0 && (
          <p className="t-text-body-sm t-text-text-30">None</p>
        )}
        {lines.map((line, index) => {
          const isFiling = line.startsWith(BULLET_PREFIX);
          const text = isFiling ? line.slice(BULLET_PREFIX.length) : line;
          const lineClassName = isFiling
            ? "t-pl-4 t-text-body-sm t-text-text-60"
            : "t-mt-2 t-text-body-sm t-font-medium t-text-text-100 first:t-mt-0";
          return (
            <p key={`${line}-${index}`} className={lineClassName}>
              {text}
            </p>
          );
        })}
      </div>
    </div>
  );
};
